import { AgreementName } from './types'

export const AgreementLabelMapping: Record<AgreementName, string> = {
  MASTER_CLIENT_AGREEMENT: 'masterServicesAgreement',
  MASTER_CLIENT_AGREEMENT_US: 'masterServicesAgreementUS',
  UK_EMI: 'ukEmi',
  MALTA_EMI: 'maltaEmi',
}
